import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SideBar from "../components/SideBar";
import Tab from "../components/Tab";
import styles from "../styles/tabs.module.css";

import { faUser, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faBell, faComment } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Breadcrumbs from "../components/Breadcrumbs";
import UserIcon from "../components/UserIcon";
import SearchBar from "../components/SearchBar";
import Footer from "../components/Footer";
function Settings(props) {
  const handleCheck = (e) => {
    setSelectedTab(e.target.value);
  };

  const tabs = {
    1: "General Settings",
    2: "Preferences",
    3: "Shipment Fee",
    4: "Currencies",
  };
  let { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  let tab = queryParams.get("tab");
  const [selectedTab, setSelectedTab] = useState(tab);

  useEffect(() => {
    setSelectedTab(queryParams.get("tab"));
  }, [tab]);

  return (
    <div className="w-[96%] text-[17px] m-auto mt-6">
      <div className="m-auto mt-6 flex">
        <div>
          <SideBar />
        </div>
        <div className="w-full flex flex-col ml-6 text-[#033362] font-semibold">
          <div className="flex justify-between items-center w-full">
            <Breadcrumbs
              breads={[
                {
                  title: "Settings",
                  link: "/settings?tab=1",
                },
              ]}
            />
            <div className="flex items-center h-8 w-[30%]">
              {selectedTab === "3" && <SearchBar placeholder="Search by location name"/>}
              <UserIcon/>
            </div>
          </div>
          <div className="bg-[white] grow mt-2 rounded-xl shadow-[0px_0px_16px_rgb(210,215,211)]">
            <div className={`${styles.tabs} rounded-xl`}>
              <div
                className={`${styles.tab} rounded-tl-xl pl-[20px] text-[18px] py-[10px] ${styles.selected}`}
              >
                {tabs[selectedTab]}
              </div>
              <Tab
                content="GeneralSettings"
                selectedTab={selectedTab}
                labelId="label-1"
                title="General Settings"
                value="1"
                handleCheck={handleCheck}
                url="/settings?tab=1"
              />
              <Tab
                content="Preferences"
                selectedTab={selectedTab}
                title="Preferences"
                value="2"
                handleCheck={handleCheck}
                url="/settings?tab=2"
              />
              <Tab
                content="ShipmentFee"
                selectedTab={selectedTab}
                title="Shipment Fee"
                value="3"
                handleCheck={handleCheck}
                url="/settings?tab=3"
              />
              <Tab
                content="Currencies"
                selectedTab={selectedTab}
                title="Currencies"
                value="4"
                handleCheck={handleCheck}
                url="/settings?tab=4"
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Settings;
